import { render, staticRenderFns } from "./_UserGroups.vue?vue&type=template&id=313fa56e&"
import script from "./_UserGroups.vue?vue&type=script&lang=ts&"
export * from "./_UserGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports